import React, { useEffect } from 'react'
import { TouchableOpacity } from 'react-native'
import { useNavigation } from '@react-navigation/core'
import { StackNavigationProp } from '@react-navigation/stack'
import { useDispatch } from 'react-redux'
import { StyleService, useStyleSheet } from '@src/style/service'
import { CircleIcon } from '@components'
import { AppStackParamList, CommonAuthorizedStackParamList } from '@src/navigation/types'
import { IconName, Text } from '@components/base'
import { User } from '@src/utils'
import { MobileAppFeature } from '@src/types'
import { ActionsMenuWrapperModal } from './ActionsMenuWrapperModal'

interface RouteInfo {
  text: string
  icon: IconName
  onPress: () => void
}

export const ActionsModal = () => {
  const styles = useStyleSheet(themedStyle)
  const navigation = useNavigation<StackNavigationProp<AppStackParamList>>()
  const authorizedNavigation = useNavigation<StackNavigationProp<CommonAuthorizedStackParamList>>()

  const dispatch = useDispatch()

  const hasOwnSensorActivationAccess = User.hasFeature(MobileAppFeature.ActivateOwnSensor)

  useEffect(() => {
    dispatch({ type: 'users/fetch' })
  }, [dispatch])

  const routes: RouteInfo[] = [
    {
      text: 'Add Meal',
      icon: 'fork-knife',
      onPress: () => {
        navigation.replace('AddMeal')
      },
    },
    {
      text: 'Add Activity',
      icon: 'pulse',
      onPress: () => {
        navigation.replace('AddActivity')
      },
    },
    {
      text: 'Journal',
      icon: 'pen',
      onPress: () => {
        navigation.replace('AddJournalEntry')
      },
    },
    {
      text: 'Add Measurement',
      icon: 'ruler',
      onPress: () => {
        navigation.replace('AddMeasurement')
      },
    },
    {
      text: 'Upload Lab Results',
      icon: 'test-tube',
      onPress: () => {
        navigation.replace('AddLabResults', { closeIcon: true })
      },
    },
  ]

  if (hasOwnSensorActivationAccess) {
    routes.unshift({
      text: 'Activate a Sensor',
      icon: 'scan',
      onPress: () =>
        authorizedNavigation.replace('OwnSensorSelection', {
          nextScreen: 'ConfirmSensorSelection',
        }),
    })
  }

  const renderActionItem = (routeInfo: RouteInfo, index: number) => {
    const { text, icon } = routeInfo
    const spacingStyle = { marginBottom: index === routes.length - 1 ? 0 : 16 }

    return (
      <TouchableOpacity
        testID={`ActionsModal/${text}`}
        key={text}
        style={[styles.action, spacingStyle]}
        activeOpacity={0.6}
        onPress={routeInfo.onPress}
        accessibilityLabel={text}
      >
        <CircleIcon name={icon} style={styles.icon} />
        <Text type="large" bold>
          {text}
        </Text>
      </TouchableOpacity>
    )
  }

  return <ActionsMenuWrapperModal>{routes.reverse().map(renderActionItem)}</ActionsMenuWrapperModal>
}

const themedStyle = StyleService.create({
  action: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 16,
  },
  disabledAction: {
    opacity: 0.3,
  },
  icon: {
    marginRight: 16,
    padding: 16,
  },
})
